import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Input, Output, EventEmitter } from '@angular/core';

@Component({
	standalone: true,
	selector: 'input-switch',
	templateUrl: './input-switch.component.html',
	imports: [ CommonModule, FormsModule ]
})
export class InputSwitchComponent implements OnInit {
	
	@Input() label: any | undefined;
	@Input() isActive: any;
	@Output() isActiveChange: EventEmitter<any> = new EventEmitter<any>();
	@Input() toggleFn: () => void;
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		
	}
	
	onClick() {
		this.isActive = !this.isActive;
		this.isActiveChange.emit(this.vm.isActive);
		this.toggleFn();
	}
	
}